/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { LoginService } from '../login.service';
import { LogincallbackComponent } from './logincallback.component';

@Component({
  selector: 'app-logincallback',
  templateUrl: './logincallback.component.html',
  styleUrls: ['./logincallback.component.scss']
})
export class SignercallbackComponent extends LogincallbackComponent {

  constructor(route: ActivatedRoute, loginsvc: LoginService, router: Router) {
    super(route, loginsvc, router);
  }

  ngOnInit() {
    this.setProgress(this.Message_ValidatingSession, 0);
    setTimeout(() => {
      let userInfo = this.getLoginService().GetSessionUserInfo();
      if (!this.getLoginService().IsSignedIn(userInfo))
        this.setProgress(this.Message_UnableToProcessLogin, 0);
      else
        this.setProgress(this.Message_LoadingPage, 0);

      setTimeout(() => {
        this.showProgress = false;
      }, 1000);
    }, this.processTimeout);
  }
}
